import React from 'react';

import {
    Checkbox,
} from '/components/forms/components';

import '/components/forms/components/checkbox-field/checkbox-field.scss';

const CheckboxField = ({ name, label, required }) => (
    <div className="form-item">
        <Checkbox name={name} label={label} required={required} />
    </div>
);

CheckboxField.propTypes = {
    ...Checkbox.propTypes,
};

CheckboxField.defaultProps = {
    ...Checkbox.defaultProps,
};

export { CheckboxField };
